/**
 * Created by Rodrigo Quesada on 27/04/17.
 */
import {NgModule} from '@angular/core';
import {PageStateService} from './page-state.service';

@NgModule({
    providers: [PageStateService]
})
export class PageServicesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/services/page-services.module.ts